import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { shipperSignUpImage, zeusLogo } from 'src/component/util/image'

export const HaulierSignUpBanner = (): React.ReactElement => {
  return (
    <Container className="background-image color-white d-flex flex-column ms-0 me-0">
      <Row className="px-lg-1 pt-5 pb-3">
        <Col lg={1}></Col>
        <Col lg={10}>
          <h1>
            <img src={zeusLogo} className="logo-position" />
          </h1>
        </Col>
        <Col lg={1}></Col>
      </Row>
      <Row className="px-lg-1 py-3">
        <Col lg={1}></Col>
        <Col lg={10}>
          <h1 className="color-secondary pb-3">
            <b className="font-36">Hauliers</b>
          </h1>
          <p>
            <b className="font-18">Register today to the fastest growing freight platform in the UK. </b>
          </p>
        </Col>
        <Col lg={1}></Col>
      </Row>
      <Row className="px-lg-1 py-1">
        <Col lg={1}></Col>
        <Col lg={7}>
          <ul>
            <li className="font-18">Free to use (no subscriptions, no user fees)</li>
            <li className="font-18">Find freight that matches your fleet</li>
            <li className="font-18">Free Driver app - access work on the go</li>
            <li className="font-18">Fast and easy to use booking system</li>
            <li className="font-18">Fast payment terms of 2 - 5 days</li>
          </ul>
        </Col>
        <Col lg={4}></Col>
      </Row>
      <Row className="px-lg-1 py-1 mb-auto">
        <Col lg={1}></Col>
        <Col lg={5}>
          <p className="font-18">
            Looking to ship? <br />
            <a className="color-green font-18" href="https://www.yourzeus.com/contact">
              Contact us
            </a>
            <br />
            and we can give you a same-day quote.
          </p>
        </Col>
        <Col lg={6}></Col>
      </Row>
      <Row className="px-lg-1 py-5">
        <Col lg={1}></Col>
        <Col lg={10} style={{ paddingLeft: '2rem' }}>
          <h5>
            <b className="color-primary font-20">Join the</b>
            <br></br>
            <b className="color-primary font-20">Future of Freight. </b>
          </h5>
        </Col>
      </Row>
    </Container>
  )
}
